// ADR 29.9.26al §1 — one value per window class, from the one measurement.
//
// Pages choose a composition (a class string, a column count, an arrangement
// word of their own) with this and never with a Tailwind `sm:`/`md:` screen:
// a screen prefix is a second copy of the boundary `windowSizeTable.ts` owns.
//
// **Keyed, never switched.** A `switch` or an `===` against a size-class slug
// puts a quoted literal in the file, and 6.9.26p AC6 fails any non-exempt file
// that does. The record below has unquoted keys, so it passes.

import type { WindowSizeClass } from './useWindowClass'

/** One value per class; an omitted class takes the next one down (expanded → medium → compact). */
export interface PerClass<T> {
  compact: T
  medium?: T
  expanded?: T
}

export function byWindowClass<T>(sizeClass: WindowSizeClass, values: PerClass<T>): T {
  const medium = values.medium ?? values.compact
  const table: Record<WindowSizeClass, T> = {
    compact: values.compact,
    medium,
    expanded: values.expanded ?? medium,
  }
  return table[sizeClass]
}
